import { api } from '../../config/base-api';
import type { MakePaymentV3Params, MakePaymentV3Response } from './types';

const PAYMENT_TIMEOUT_IN_MS = 120000; // 2 minutes

export async function makePaymentV3(
  paymentData: MakePaymentV3Params,
  isServer?: boolean
): Promise<MakePaymentV3Response> {
  const requestUrl = isServer
    ? 'http://localhost:3000/api/v3/payment'
    : '/api/v3/payment';

  const res = await api.post<MakePaymentV3Response>(requestUrl, paymentData, {
    timeout: PAYMENT_TIMEOUT_IN_MS,
  });

  return res.data;
}
